import {useState, useEffect} from "react";
import "./Jepx.css";
import Jepx_chart from "./JepxChart.js";
import { Container, Table,Grid,Flex,LoadingOverlay } from '@mantine/core';
import { DatePicker } from '@mantine/dates';

// API
import {
  API_JEPX_DATA_POST,
} from './UtilitiesApi.js';

import 'dayjs/locale/ja';
import dayjs from "dayjs";

const getTomorrow = () => {
  const now = new Date();
  const japanOffset = 9 * 60; // Japan Standard Time (UTC+9) in minutes
  const currentJapanTime = new Date(now.getTime() + (now.getTimezoneOffset() + japanOffset) * 60000);

  if (currentJapanTime.getHours() >= 11) {
    currentJapanTime.setDate(currentJapanTime.getDate() + 1);
  }

  return currentJapanTime;
};

// Set the zoom level of the body
if (window.innerWidth < 1920) {
  document.body.style.zoom = '67%'; // Small screens
} else {
  document.body.style.zoom = '90%'; // Large screens
}


function Jepx_price (props){

  // useEffect(() => {
  //   // Set the zoom level of the body
  //   if (window.innerWidth < 1920) {
  //     document.body.style.zoom = '67%'; // Small screens
  //   } else {
  //     document.body.style.zoom = '90%'; // Large screens
  //   }
  // }, []);

  const [screenWidth, setscreenWidth] = useState(window.innerWidth);
  const [selectedDate, setSelectedDate] = useState(getTomorrow);
  const [loading, setloading] = useState(false);
  const [data_jepx, setdata_jepx] = useState(null)
  const [keisan_data, setkeisan_data] = useState(null)
  const [ErrorMessage, setErrorMessage]  = useState("データが見つかりません")

  const timezoneOffset = (new Date()).getTimezoneOffset();

  // setSelectedDate、日付を選んだ場合
  const handleChange = async(e) => {
    if (e == null) {
      setSelectedDate(new Date())
    }
    else{
      setSelectedDate(e)
    }

  };

  useEffect(() => {

    const MakeKeisanData = async(data_s3) => {
      const DataKeisan = {}
      const time_period = ["00:00","06:00","10:00","14:00","18:00","23:30"]
      for(let x of Object.getOwnPropertyNames(data_s3).slice(1)){
        const cut_data = {}
        for(let i=0; i<time_period.length-1; i++){
          const startTimeindex = data_s3["日付時刻"].indexOf(time_period[i])
          const endTimeindex = data_s3["日付時刻"].indexOf(time_period[i+1])
        
          const Time = data_s3["日付時刻"].slice(startTimeindex,endTimeindex+1)
          let dataOfTime;
          if(time_period[i+1]=="23:30"){
            dataOfTime = data_s3[x].slice(startTimeindex,endTimeindex+1)
          }
          else{
            dataOfTime = data_s3[x].slice(startTimeindex,endTimeindex)
          }
          const Avg = parseFloat(((dataOfTime.reduce((acc,val)=>acc+val,0))/dataOfTime.length)).toFixed(2)
        
          const max_value = Math.max(...dataOfTime)
          let TimePeriod_max;
          if(Time[dataOfTime.indexOf(max_value)]=="23:30"){
            TimePeriod_max = `${Time[dataOfTime.indexOf(max_value)]}~00:00`
          }
          else{
            TimePeriod_max = `${Time[dataOfTime.indexOf(max_value)]}~${Time[(dataOfTime.indexOf(max_value))+1]}`
          }
          
          const Max = {
            "Value":max_value.toFixed(2),
            "TimePeriod":TimePeriod_max,
            "All_Max":Math.max(...data_s3[x]),
          }
          
          const min_value = Math.min(...dataOfTime)
          let TimePeriod_min;
          if(Time[dataOfTime.indexOf(min_value)]=="23:30"){
            TimePeriod_min = `${Time[dataOfTime.indexOf(min_value)]}~00:00`
          }
          else{
            TimePeriod_min = `${Time[dataOfTime.indexOf(min_value)]}~${Time[(dataOfTime.indexOf(min_value))+1]}`
          }
          const Min = {
            "Value":min_value.toFixed(2),
            "TimePeriod":TimePeriod_min,
            "All_Min":Math.min(...data_s3[x]),
          }
        
          cut_data[`${time_period[i]}~${time_period[i+1]}`] = {
            "Time":Time,
            "Data":dataOfTime,
            "Avg":Avg,
            "Max":Max,
            "Min":Min,
          }
          
        }
        DataKeisan[x] = cut_data
      }
      return DataKeisan
    }

    const fetchData = async () => {
      setloading(true)
      const formattedDate = selectedDate ? dayjs(selectedDate).format('YYYY/MM/DD') : null;
      if (formattedDate !== null) {
        try {
          const result_data = await API_JEPX_DATA_POST(formattedDate);
          if (result_data["status"] === "ok") {
            setdata_jepx(result_data["data"]);
            const NewdataKeisan = await MakeKeisanData(result_data["data"])
            setkeisan_data(NewdataKeisan)
            setscreenWidth(window.innerWidth)
          } else {
            console.error("Error: Data fetch failed.");
            setdata_jepx(null);
            setkeisan_data(null)
            setErrorMessage(result_data["message"])
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      setloading(false)
    };
  
    fetchData();


  }, [selectedDate]);

  // 11時前は今日のデータ、11時後は明日のデータ設定
  function getDefaultDate() {
    const today = new Date();
    if(timezoneOffset==0){
      const fiveAM = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 2, 0, 0);
      if (today.getTime() >= fiveAM.getTime()) {
      return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    } 
    else {
      return today;
    }
    }else{
    const elevenAM = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 0, 0);
      if (today.getTime() >= elevenAM.getTime()) {
      return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    } 
    else {
      return today;
    }
    }
    
  }

  try{
    return (
      <>
      <LoadingOverlay visible={loading} zIndex={1000} />
        <Container fluid style={{
          width:"100%",
          filter: loading ? 'blur(5px)' : 'none',
          pointerEvents: loading ? 'none' : 'auto',
          }}>
            <div>
                <Flex
                    mih={50}
                    // bg="rgba(0, 0, 0, .3)"
                    gap="xl"
                    justify="flex-start"
                    align="flex-start"
                    direction="row"
                    wrap="wrap-reverse"
                    sx={{
                      marginBottom:"10px",
                      borderBottom: "3px solid rgba(122, 122, 122, 0.999)" // Adds a bottom border
  
                    }}
                  >
                        <div style={{
                                        fontFamily: 'var(--font-family-m_plus_1)', // Correct camelCase for fontFamily
                                        fontSize: '18px',                           // Ensure values are strings
                                        fontStyle: 'normal',
                                        fontWeight: 900
                                    }}>
                            各エリアの市場価格: 
                        </div>
  
                        <DatePicker
                          size={20}
                          styles={{
                            root: { border: '2px solid white', color:'red' },
                            input: { color: '#4572c4', fontWeight: 600 },
                          }}
                          locale='ja'
                          value={
                            selectedDate==null?(
                              getDefaultDate() 
                            ):
                            selectedDate
                          }
                          onChange={(e)=>handleChange(e)}
                          placeholder="YYYY年MM月DD日dd"
                          inputFormat="YYYY年MM月DD日(dd)"
                          minDate={dayjs(new Date(2023,2,28)).toDate()}
                          maxDate={getDefaultDate()}
                        />
  
                    <img 
                      style={{
                          height:"60px",
                          width:"48px",
                          position:"relative",
                          right:"70px",
                          top:"10px"
                      }} 
                      src={"/img/jepx/powerkun.png"}alt="Group" 
                    />
  
              <img
                  style={{
                    height: "55px",
                    marginTop: "5px",
                    marginBottom: "5px",
                    marginLeft: "auto"  // Push the image to the far right
                  }}
                  src={"/img/shirokuma.png"}
                  alt="Group"
                />
  
  
                
                </Flex>
  
              {
                data_jepx!==null?(
                  <Container 
                      fluid 
                      style={{
                          width: "100%", 
                      }}
                    >
                      <Grid grow >
                        
                        <Grid.Col span={4} >
                            <Container
                                style={{
                                  width: "100%", 
                                  display: "flex",            // Makes the container a flexbox
                                  justifyContent: "center",    // Centers the grid horizontally
                                }}
                            >
                                            <Jepx_chart use_data={data_jepx["北海道の価格"]} name={"北海道エリア"} color={"#9cb0da"}/>
                            </Container>
  
                        </Grid.Col>
  
                        <Grid.Col span={4} >
  
                              <Container
                                  style={{
                                    display: "flex",            // Makes the container a flexbox
                                    justifyContent: "center",    // Centers the grid horizontally
                                  }}
                              >
                                              <Jepx_chart use_data={data_jepx["東北の価格"]} name={"東北エリア"} color={"#88ced3"}/>
                              </Container>
                            
                          
                        </Grid.Col>
  
                        <Grid.Col span={4} >
                            <Container
                                  style={{
                                    display: "flex",            // Makes the container a flexbox
                                    justifyContent: "center",    // Centers the grid horizontally
                                  }}
                              >
                                              <Jepx_chart use_data={data_jepx["東京の価格"]} name={"東京エリア"} color={"#f5b4a3"}/>
                              </Container>
                          
                        </Grid.Col>
  
  
                        <Grid.Col span={4} >
                              <Container
                                  style={{
                                    display: "flex",            // Makes the container a flexbox
                                    justifyContent: "center",    // Centers the grid horizontally
                                  }}
                              >
                                              <Jepx_chart use_data={data_jepx["中部の価格"]} name={"中部エリア"} color={"#fee565"}/>
                            </Container>
                        </Grid.Col> 
  
  
                        <Grid.Col span={4}>
                              <Container
                                        style={{
                                          display: "flex",            // Makes the container a flexbox
                                          justifyContent: "center",    // Centers the grid horizontally
                                        }}
                              >
                                              <Jepx_chart use_data={data_jepx["北陸の価格"]} name={"北陸エリア"} color={"#87c2eb"}/>
                            </Container>
                        </Grid.Col>
  
                        <Grid.Col span={4}>
                              <Container
                                              style={{
                                                display: "flex",            // Makes the container a flexbox
                                                justifyContent: "center",    // Centers the grid horizontally
                                              }}
                                    >
                                              <Jepx_chart use_data={data_jepx["関西の価格"]} name={"関西エリア"} color={"#c3a679"}/>
                              </Container>
                        </Grid.Col>
  
                        
                        <Grid.Col span={4}>
                              <Container
                                              style={{
                                                display: "flex",            // Makes the container a flexbox
                                                justifyContent: "center",    // Centers the grid horizontally
                                              }}
                                    >
                                              <Jepx_chart use_data={data_jepx["中国の価格"]} name={"中国エリア"} color={"#c0a4c1"}/>
                              </Container>
                        </Grid.Col>
  
                        
                        <Grid.Col span={4}>
                              <Container
                                              style={{
                                                display: "flex",            // Makes the container a flexbox
                                                justifyContent: "center",    // Centers the grid horizontally
                                              }}
                                    >
                                              <Jepx_chart use_data={data_jepx["四国の価格"]} name={"四国エリア"} color={"#f6b262"}/>
                              </Container>
                        </Grid.Col>
  
                        <Grid.Col span={4}>
                              <Container
                                              style={{
                                                display: "flex",            // Makes the container a flexbox
                                                justifyContent: "center",    // Centers the grid horizontally
                                              }}
                                    >
                                              <Jepx_chart use_data={data_jepx["九州の価格"]} name={"九州エリア"} color={"#6badde"}/>
                              </Container>
                        </Grid.Col>
  
                        {
                          screenWidth>1092?(
                            <Grid.Col span={4}>
          
                            </Grid.Col>
                          ):<></>
                        }
                        
                        
  
                      </Grid>
                    </Container>
                ):
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh', // Full viewport height to vertically center
                  textAlign: 'center',
                  fontSize: '24px', // Adjust font size for better readability
                  fontWeight: 'bold', // Make the text bold
                  color: '#555', // Softer color for better aesthetics
                }}>
                  {ErrorMessage}
                </div>
              }
              
            </div>

            {/* SPACE 50px */}
            <div
              style={{
                height:"200px",
                border: '2px solid white',
              }}
            >

            </div>
  
            <div>
  
                <Flex
                    mih={50}
                    // bg="rgba(0, 0, 0, .3)"
                    gap="xl"
                    justify="flex-start"
                    align="flex-start"
                    direction="row"
                    wrap="wrap-reverse"
                    sx={{
                      marginBottom:"10px",
                      borderBottom: "3px solid rgba(122, 122, 122, 0.999)" // Adds a bottom border
  
                    }}
                >
                            <div style={{
                                            fontFamily: 'var(--font-family-m_plus_1)', // Correct camelCase for fontFamily
                                            fontSize: '18px',                           // Ensure values are strings
                                            fontStyle: 'normal',
                                            fontWeight: 900
                                        }}>
                                各エリアの市場価格: 
                            </div>
  
                            <DatePicker
                              size={20}
                              styles={{
                                root: { border: '2px solid white', color:'red' },
                                input: { color: '#4572c4', fontWeight: 600 },
                              }}
                              locale='ja'
                              value={
                                selectedDate==null?(
                                  getDefaultDate() 
                                ):
                                selectedDate
                              }
                              onChange={(e)=>handleChange(e)}
                              placeholder="YYYY年MM月DD日dd"
                              inputFormat="YYYY年MM月DD日(dd)"
                              minDate={dayjs(new Date(2023,2,28)).toDate()}
                              maxDate={getDefaultDate()}
                            />
  
                        <img 
                          style={{
                              height:"60px",
                              width:"48px",
                              position:"relative",
                              right:"70px",
                              top:"10px"
                          }} 
                          src={"/img/jepx/powerkun.png"}alt="Group" 
                        />
  
                      <img
                          style={{
                            height: "55px",
                            marginTop: "5px",
                            marginBottom: "5px",
                            marginLeft: "auto"  // Push the image to the far right
                          }}
                          src={"/img/shirokuma.png"}
                          alt="Group"
                        />
  
                </Flex>
  
                {
                  keisan_data!==null && data_jepx!==null?(
                    <>
                      <div className="">
  
                          <Grid grow >
                              <div className="" 
                              style={{
                                width:1890,
                                overflow:"auto",
                                padding: 16, 
                                flexGrow: 1,
  
                              }}>
                                <Table horizontalSpacing={1} fontSize={11} withBorder withColumnBorders 
                                    style={{ 
                                          textAlign: 'center', fontWeight:'bold',
                                          bgcolor: 'background.paper',
                                          position: 'relative',
                                          overflow: 'auto',
                                          flexGrow: 1,
                                          '& ul': { padding: 0 },
                                      }}
                                >
                                  <thead>
                                    <tr>
                                      <th style={{border: '1px solid white', borderRight: '1px solid black', borderBottom: '1px solid black'}}></th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>00:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>00:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>01:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>01:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>02:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>02:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>03:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>03:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>04:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>04:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>05:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>05:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>06:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>06:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>07:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>07:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>08:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>08:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>09:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>09:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>10:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>10:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>11:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>11:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>12:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>12:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>13:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>13:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>14:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>14:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>15:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>15:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>16:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>16:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>17:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>17:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>18:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>18:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>19:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>19:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>20:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>20:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>21:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>21:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>22:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>22:30</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>23:00</th>
                                      <th style={{ textAlign: 'center',border: '1px solid black' }}>23:30</th>
                                    </tr>
                                  </thead>
                                  
                                  <tbody>
                                    {
                                      Object.getOwnPropertyNames(data_jepx).slice(1).map((property)=>(
                                        <tr key={property}>
                                          <td key={property} style={{ minWidth: 70, fontSize:15, border:'1px solid black',fontWeight: '500'}}>{property.replace("の価格","")}</td>
                                          {
                                            data_jepx[property].map((value,index)=>(
                                              value<3?(
                                                <td key={`${property}_${index}`} style={{ background:'#e1eeda',border: '1px solid black'}}>{value.toFixed(2)}</td>
                                              ):
                                              value>=3 && value<5?(
                                              <td key={`${property}_${index}`} style={{ background:'#c6e1b4',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                              ):
                                              value>=5 && value<10?(
                                                <td key={`${property}_${index}`} style={{ background:'#bed6ee',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                ):
                                                value>=10 && value<15?(
                                                  <td key={`${property}_${index}`} style={{ background:'#24aaff',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                  ):
                                                  value>=15 && value<20?(
                                                    <td key={`${property}_${index}`} style={{ background:'#0141ff',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                    ):
                                                    value>=20 && value<30?(
                                                      <td key={`${property}_${index}`} style={{ background:'#fae695',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                      ):
                                                      value>=30 && value<40?(
                                                        <td key={`${property}_${index}`} style={{ background:'#ffe700',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                        ):
                                                        value>=40 && value<50?(
                                                          <td key={`${property}_${index}`} style={{ background:'#fb9900',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                          ):
                                                          value>=50 && value<80?(
                                                            <td key={`${property}_${index}`} style={{ background:'#f82803',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                            ):
                                                            value>=80 && value<100?(
                                                              <td key={`${property}_${index}`} style={{ background:'#a40121',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                              ):
                                                              value>=100?(
                                                                <td key={`${property}_${index}`} style={{ background:'#b40867',border: '1px solid black' }}>{value.toFixed(2)}</td>
                                                                ):
                                              <td key={`${property}_${index}`} style={{ background:'white' }}>{value.toFixed(2)}</td>
                                              )
                                            )
                                          }
                                        </tr>
                                        )
                                      )
                                    }
                                  </tbody> 
  
                                </Table>
                              </div>
                          </Grid>
                          
                          <div className="hanrei">
                            <Table horizontalSpacing={-1} fontSize={10} style={{ padding:'1px',border: '1px solid black', textAlign: 'center', width:600, height:10}}>
                            <thead>
                              <tr style={{ padding: '1px' }}>
                              <th style={{ border: '1px solid white', borderRight: '1px solid black' ,textAlign: 'center', width:150, position: 'relative', top: '10px', fontSize:20 , color:'black'}}>【凡例】</th>
                                <th style={{ border: '1px solid black', background:'#e1eeda', textAlign: 'center', color:'black'}}>3円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#c6e1b4', textAlign: 'center', color:'black' }}>5円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#bed6ee', textAlign: 'center', color:'black' }}>10円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#24aaff', textAlign: 'center', color:'black' }}>15円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#0141ff', textAlign: 'center', color:'white' }}>20円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#fae695', textAlign: 'center', color:'black' }}>30円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#ffe700', textAlign: 'center', color:'black' }}>40円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#fb9900', textAlign: 'center', color:'black' }}>50円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#f82803', textAlign: 'center', color:'black' }}>80円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#a40121', textAlign: 'center', color:'white' }}>100円<br/>未満</th>
                                <th style={{ border: '1px solid black', background:'#b40867', textAlign: 'center', color:'white' }}>100円<br/>以上</th>
                              </tr>
                            </thead>
                            </Table>
                          </div>
  
                      </div>
  
                      <Container fluid>
                          <Grid grow>
                            {
                              Object.getOwnPropertyNames(keisan_data).map((key)=>(
                                <Grid.Col span={4}>
                                  <div key ={keisan_data} style={{lineHeight: '40px',height:40,border: '1px solid #808080', background:'#d9d9d9', textAlign: 'center', fontSize:25, color:'black'}}>{key.replace("の価格", "エリア")}</div>
                                    <Table fontSize={15}>
                                        <thead>
                                          <tr></tr>
                                        <tr >
                                          <th key ={`${keisan_data}_時間帯`} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black'}}>時間帯</th>
                                          <th key ={`${keisan_data}_0:00~6:00`} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black', fontSize:15}}>0:00~6:00</th>
                                          <th key ={`${keisan_data}_6:00~10:00`} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black', fontSize:15}}>6:00~10:00</th>
                                          <th key ={`${keisan_data}_10:00~14:00`} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black', fontSize:15}}>10:00~14:00</th>
                                          <th key ={`${keisan_data}_14:00~18:00`} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black', fontSize:15}}>14:00~18:00</th>
                                          <th key ={`${keisan_data}_18:00~24:00`} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black', fontSize:15}}>18:00~24:00</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          // Object.getOwnPropertyNames(data_s3).slice(1).map((property)=>())
                                          ["平均","最高値","最安値"].map((name)=>(
                                            name=="平均"?
                                            (
                                            <tr key={`${keisan_data}_${name}`}>
                                              <td key={name} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black', fontWeight: 'bold'}}>{name}</td>
                                              {
                                                Object.getOwnPropertyNames(keisan_data[key]).map((property)=>(
                                                  <td key={property} style={{ border: '1px solid #808080', background:'white', textAlign: 'center', color:'black',fontWeight: 'bold', fontSize:21}}>{keisan_data[key][property]["Avg"]}</td>
                                                ))
                                              }
                                            </tr>
                                            ):
                                            name=="最高値"?(
                                            <tr key={name}>
                                              <td  key={name} style={{ border: '1px solid #808080', background:'#fdd6d9', textAlign: 'center', color:'#bf0000',fontWeight: 'bold'}}>{name}<br/>(時間帯)</td>
                                              {
                                                  Object.getOwnPropertyNames(keisan_data[key]).map((property)=>(
                                                    keisan_data[key][property]["Max"]["Value"]==keisan_data[key][property]["Max"]["All_Max"]?(
                                                    <td key={property} style={{ border: '1px solid #808080', background:'#f80103', textAlign: 'center', color:'white' }}>
                                                    <span style={{ fontWeight: 'bold', fontSize:21 }}>{keisan_data[key][property]["Max"]["Value"]}</span><br/>{keisan_data[key][property]["Max"]["TimePeriod"]}</td>
                                                    ):
                                                    <td key={property} style={{ border: '1px solid #808080', background:'#fdd6d9', textAlign: 'center', color:'#bf0000'}}>
                                                    <span style={{ fontWeight: 'bold', fontSize:21 }}>{keisan_data[key][property]["Max"]["Value"]}</span><br/>{keisan_data[key][property]["Max"]["TimePeriod"]}</td>
                                                ))
  
                                              }
                                            </tr>
                                            ):
                                            <tr key={name}>
                                              <td key={"最安値"} style={{ border: '1px solid #808080', background:'#d9e1f1', textAlign: 'center',color:'#1170c0',fontWeight: 'bold'}}>{name}<br/>(時間帯)</td>
                                              {
                                                  Object.getOwnPropertyNames(keisan_data[key]).map((property)=>(
                                                    keisan_data[key][property]["Min"]["Value"]==keisan_data[key][property]["Min"]["All_Min"]?(
                                                    <td key={property}　style={{ border: '1px solid #808080', background:'#2f76b5', textAlign: 'center', color:'white'}}>
                                                    <span style={{ fontWeight: 'bold' , fontSize:21}}>{keisan_data[key][property]["Min"]["Value"]}</span><br/>{keisan_data[key][property]["Min"]["TimePeriod"]}</td>
                                                    ):
                                                    <td key={property} style={{ border: '1px solid #808080', background:'#d9e1f1', textAlign: 'center', color:'#1170c0'}}>
                                                    <span style={{ fontWeight: 'bold' , fontSize:21}}>{keisan_data[key][property]["Min"]["Value"]}</span><br/>{keisan_data[key][property]["Min"]["TimePeriod"]}</td>
                                                ))
  
                                              }
                                            </tr>
                                          ))
                                        }
                                      </tbody>
                                    </Table>
                                </Grid.Col>
                              ))
                            }
  
                            {
                              screenWidth>1092?(
                                <Grid.Col span={4}>
              
                                </Grid.Col>
                              ):<></>
                            }
  
                          </Grid>
                      </Container>
                    </>
                  ):<></>
                }
                
                        
                <div style={{margin: '20px 0'}} className="Text">
                    ・表の数字について:30分ごと×エリアにおける電力のスポット価格です。単位は円/kWhとなります。この価格に基づき、ご請求金額を決定いたします。
                    <div style={{margin: '10px 0'}}>
                    ・エリア(価格):エリア毎の取引価格になります。各大手電力管内を指しています(例:東京→東京電力)。日本では東日本での電気が50Hz、西日本では60Hzとなっております。他にも各エリアを跨ぐ際の容量に上限があるため、エリア別の価格が存在します
                    </div>
                    <div style={{margin: '10px 0'}}>
                    ・時間:日本では30分毎に電気の取引価格が決まっており、表では各時間帯の始まりを示しています(例:14:00→14:00~14:30)
                    </div>
                    <div style={{margin: '10px 0'}}>
                    ・データの出典:[日本卸電力取引所] http://www.jepx.org/
                    </div>
                </div>
  
            </div>
  
        </Container>  
      </>
    );

  }catch(e){
    setErrorMessage("サーバー側でエラーが発生しました。")
    return (
      <>
      <LoadingOverlay visible={loading} zIndex={1000} />
        <Container fluid style={{
          width:"100%",
          filter: loading ? 'blur(5px)' : 'none',
          pointerEvents: loading ? 'none' : 'auto',
          }}>
            <div>
                <Flex
                    mih={50}
                    // bg="rgba(0, 0, 0, .3)"
                    gap="xl"
                    justify="flex-start"
                    align="flex-start"
                    direction="row"
                    wrap="wrap-reverse"
                    sx={{
                      marginBottom:"10px",
                      borderBottom: "3px solid rgba(122, 122, 122, 0.999)" // Adds a bottom border
  
                    }}
                  >
                        <div style={{
                                        fontFamily: 'var(--font-family-m_plus_1)', // Correct camelCase for fontFamily
                                        fontSize: '18px',                           // Ensure values are strings
                                        fontStyle: 'normal',
                                        fontWeight: 900
                                    }}>
                            各エリアの市場価格: 
                        </div>
  
                        <DatePicker
                          size={20}
                          styles={{
                            root: { border: '2px solid white', color:'red' },
                            input: { color: '#4572c4', fontWeight: 600 },
                          }}
                          locale='ja'
                          value={
                            selectedDate==null?(
                              getDefaultDate() 
                            ):
                            selectedDate
                          }
                          onChange={(e)=>handleChange(e)}
                          placeholder="YYYY年MM月DD日dd"
                          inputFormat="YYYY年MM月DD日(dd)"
                          minDate={dayjs(new Date(2023,2,28)).toDate()}
                          maxDate={getDefaultDate()}
                        />
  
                    <img 
                      style={{
                          height:"60px",
                          width:"48px",
                          position:"relative",
                          right:"70px",
                          top:"10px"
                      }} 
                      src={"/img/jepx/powerkun.png"}alt="Group" 
                    />
  
              <img
                  style={{
                    height: "55px",
                    marginTop: "5px",
                    marginBottom: "5px",
                    marginLeft: "auto"  // Push the image to the far right
                  }}
                  src={"/img/shirokuma.png"}
                  alt="Group"
                />
  
  
                
                </Flex>

                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh', // Full viewport height to vertically center
                  textAlign: 'center',
                  fontSize: '24px', // Adjust font size for better readability
                  fontWeight: 'bold', // Make the text bold
                  color: '#555', // Softer color for better aesthetics
                }}>
                  {ErrorMessage}
                </div>
  

              
            </div>
  
            <div>
  
                <Flex
                    mih={50}
                    // bg="rgba(0, 0, 0, .3)"
                    gap="xl"
                    justify="flex-start"
                    align="flex-start"
                    direction="row"
                    wrap="wrap-reverse"
                    sx={{
                      marginBottom:"10px",
                      borderBottom: "3px solid rgba(122, 122, 122, 0.999)" // Adds a bottom border
  
                    }}
                >
                            <div style={{
                                            fontFamily: 'var(--font-family-m_plus_1)', // Correct camelCase for fontFamily
                                            fontSize: '18px',                           // Ensure values are strings
                                            fontStyle: 'normal',
                                            fontWeight: 900
                                        }}>
                                各エリアの市場価格: 
                            </div>
  
                            <DatePicker
                              size={20}
                              styles={{
                                root: { border: '2px solid white', color:'red' },
                                input: { color: '#4572c4', fontWeight: 600 },
                              }}
                              locale='ja'
                              value={
                                selectedDate==null?(
                                  getDefaultDate() 
                                ):
                                selectedDate
                              }
                              onChange={(e)=>handleChange(e)}
                              placeholder="YYYY年MM月DD日dd"
                              inputFormat="YYYY年MM月DD日(dd)"
                              minDate={dayjs(new Date(2023,2,28)).toDate()}
                              maxDate={getDefaultDate()}
                            />
  
                        <img 
                          style={{
                              height:"60px",
                              width:"48px",
                              position:"relative",
                              right:"70px",
                              top:"10px"
                          }} 
                          src={"/img/jepx/powerkun.png"}alt="Group" 
                        />
  
                      <img
                          style={{
                            height: "55px",
                            marginTop: "5px",
                            marginBottom: "5px",
                            marginLeft: "auto"  // Push the image to the far right
                          }}
                          src={"/img/shirokuma.png"}
                          alt="Group"
                        />
  
                </Flex>
                        
                <div style={{margin: '20px 0'}} className="Text">
                    ・表の数字について:30分ごと×エリアにおける電力のスポット価格です。単位は円/kWhとなります。この価格に基づき、ご請求金額を決定いたします。
                    <div style={{margin: '10px 0'}}>
                    ・エリア(価格):エリア毎の取引価格になります。各大手電力管内を指しています(例:東京→東京電力)。日本では東日本での電気が50Hz、西日本では60Hzとなっております。他にも各エリアを跨ぐ際の容量に上限があるため、エリア別の価格が存在します
                    </div>
                    <div style={{margin: '10px 0'}}>
                    ・時間:日本では30分毎に電気の取引価格が決まっており、表では各時間帯の始まりを示しています(例:14:00→14:00~14:30)
                    </div>
                    <div style={{margin: '10px 0'}}>
                    ・データの出典:[日本卸電力取引所] http://www.jepx.org/index.html
                    </div>
                </div>
  
            </div>
  
        </Container>  
      </>
    );
  }
  
  
}

export default Jepx_price;